import {
  CLEAR_CONTRACT_TRANSACTIONS,
  CLEAR_CONTRACT_TRANSACTION_OPTIONS,
  CLEAR_TRANSACTIONS,
  CLEAR_TRANSACTION_DETAIL,
  CLEAR_TRANSACTION_OPTIONS,
  LOAD_CONTRACT_TRANSACTIONS,
  LOAD_TRANSACTIONS,
  LOAD_TRANSACTION_DETAIL,
  SAVE_CONTRACT_TRANSACTION_OPTIONS,
  SAVE_TRANSACTION_OPTIONS
} from '../actions/transactionActions';

const initialState = {
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0
  },
  items: [],
  count: 0,
  balance: 0,
  overdueAmount: 0,
  detail: {
    item: null,
    complements: [],
    relatedInvoices: [],
    error: false
  }
};

const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TRANSACTIONS.success: {
      return {
        ...state,
        items: action.items,
        count: action.count,
        balance: action.balance,
        overdueAmount: action.overdueAmount
      };
    }
    case SAVE_TRANSACTION_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    }
    case CLEAR_TRANSACTION_OPTIONS: {
      return {
        ...state,
        options: initialState.options
      };
    }
    case CLEAR_TRANSACTIONS: {
      return initialState;
    }
    case LOAD_TRANSACTION_DETAIL.start: {
      return {
        ...state,
        detail: initialState.detail
      };
    }
    case LOAD_TRANSACTION_DETAIL.success: {
      return {
        ...state,
        detail: {
          item: action.item,
          complements: action.complements,
          relatedInvoices: action.relatedInvoices ?? [],
          error: false
        }
      };
    }
    case LOAD_TRANSACTION_DETAIL.failure: {
      return {
        ...state,
        detail: {
          ...initialState.detail,
          error: true
        }
      };
    }
    case CLEAR_TRANSACTION_DETAIL: {
      return {
        ...state,
        detail: initialState.detail
      };
    }
    case LOAD_CONTRACT_TRANSACTIONS.success: {
      return {
        ...state,
        items: action.items,
        count: action.count,
        balance: action.balance,
        overdueAmount: action.overdueAmount
      };
    }
    case SAVE_CONTRACT_TRANSACTION_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    }
    case CLEAR_CONTRACT_TRANSACTION_OPTIONS: {
      return {
        ...state,
        options: initialState.options
      };
    }
    case CLEAR_CONTRACT_TRANSACTIONS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default transactionReducer;
